import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { useAppSelector } from 'src/store';
import { ProductsType } from 'src/constants/products';
import {
  IntegrationTypeAgent,
  IntegrationTypeBi,
  IntegrationTypeCustomer,
} from 'src/components/Integrations/IntegrationTypes';
import { CurrentIntegrations } from './CurrentIntegrations';
import { setSelectedIntegration } from 'src/store/slices/integrationSlice';
import { useDispatch } from 'react-redux';

export const CurrentIntegrationField = () => {
  const [integrations, setIntegrations] = useState([]);
  const { id } = useParams();
  const dispatch = useDispatch();
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [searchParams] = useSearchParams();
  const searchProjectType = searchParams.get('type');
  const { projectType } = useAppSelector((s) => s.projectsSlices);
  const type = projectType || searchProjectType || false;
  const { data: currentProject, isFetching: isFetchingProject } = useGetProjectByIdQuery({
    id: id,
  }) as any;
  const integrationTypes =
    (type === ProductsType.agent && IntegrationTypeAgent) ||
    (type === ProductsType.customer && IntegrationTypeCustomer) ||
    (type === ProductsType.bi && IntegrationTypeBi);

  useEffect(() => {
    if (currentProject && currentProject?.integrations) {
      setIntegrations(currentProject?.integrations);

      if (currentProject?.integrations[0]) {
        dispatch(
          setSelectedIntegration({ ...selectedIntegration, ...currentProject?.integrations[0] }),
        );
      }
    }
  }, [currentProject]);

  return (
    <div className="w-full pb-2.5 border-b border-b-light">
      <div>
        <CurrentIntegrations
          isFetchingProject={isFetchingProject}
          isEmpty={!integrations.length}
          integrations={integrations}
          integrationTypes={integrationTypes}
        />
      </div>
    </div>
  );
};
